import React, { useState, type FormEvent, type ReactNode } from 'react';
import './LoginGate.css';

const STORAGE_KEY = 'watch_demo_unlocked';
const ACCESS_KEY = process.env.REACT_APP_DEMO_KEY ?? 'meWATCH2026';

function isUnlocked(): boolean {
  return sessionStorage.getItem(STORAGE_KEY) === 'true';
}

export default function LoginGate({ children }: { children: ReactNode }) {
  const [unlocked, setUnlocked] = useState(isUnlocked);
  const [key, setKey] = useState('');
  const [error, setError] = useState(false);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (key.trim() === ACCESS_KEY) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      setUnlocked(true);
      setError(false);
    } else {
      setError(true);
    }
  }

  if (unlocked) return <>{children}</>;

  return (
    <div className="LoginGate">
      <form className="LoginGate__card" onSubmit={handleSubmit}>
        <div className="LoginGate__wordmark">Watch</div>
        <p className="LoginGate__subtitle">This preview is private. Enter the access key to continue.</p>
        <input
          className="LoginGate__input"
          type="password"
          autoFocus
          placeholder="Access key"
          value={key}
          onChange={(e) => {
            setKey(e.target.value);
            setError(false);
          }}
        />
        {error && <div className="LoginGate__error">That key isn't right. Try again.</div>}
        <button className="LoginGate__button" type="submit">
          Enter
        </button>
        <p className="LoginGate__contact">
          Want a detailed walkthrough of AI-native recommendations?{' '}
          <a href="https://cobuildx.ai/contact" target="_blank" rel="noopener noreferrer">
            Get in touch
          </a>
        </p>
      </form>
    </div>
  );
}
